// import React, { Context } from 'react';
// import { AppContext, AppContextInterface } from '../app-context-provider';
// export interface PageGridProps {
//   columns?: number;
//   fitContent?: boolean;
//   className?: string;
//   childrenLength?: any;
//   childrenArray?: any[];
// }

// class PageGrid extends React.Component<PageGridProps> {
//   static contextType: Context<AppContextInterface | null> = AppContext;
//   public context!: AppContextInterface;
//   public state = { deviceWidth: window.innerWidth, limit: 15 };

//   constructor(props: any) {
//     super(props);
//     this.listen = this.listen.bind(this);
//   }

//   componentDidMount() {
//     window.addEventListener('resize', this.listen);
//   }

//   componentWillUnmount() {
//     window.removeEventListener('resize', this.listen);
//   }

//   listen() {
//     this.setState({ deviceWidth: window.innerWidth });
//   }

//   getColumns() {
//     return this.props.columns || 5;
//   }
//   render() {
//     let columns = this.getColumns();
//     let gridStyle = {
//       gridTemplateColumns: `repeat(${columns}, 1fr)`,
//     };

//     let className = 'section-grid';
//     if (this.props.className) {
//       className += ' ' + this.props.className;
//     }

//     return (
//       <>
//         {/* <pre>{JSON.stringify(this.props.columns, null, 1)}</pre> */}
//         <div
//           style={gridStyle}
//           className={`${className} ${
//             this.props.childrenLength > 15 ? 'section-grid--many-items' : ''
//           }`}>
//           {this.props.childrenArray?.map(
//             (child, index) =>
//               index < this.state.limit && (
//                 <div className='section-grid-inner-container'>{child}</div>
//               )
//           )}
//           {this.props.children}
//         </div>
//         <div className='section-padding' style={{ textAlign: 'center' }}>
//           {this.props.childrenArray?.length &&
//             this.state.limit < this.props.childrenArray.length && (
//               <button
//                 className='btn'
//                 onClick={() =>
//                   this.setState({
//                     deviceWidth: window.innerWidth,
//                     limit: this?.props?.childrenArray?.length,
//                   })
//                 }>
//                 {/* Last inn alle */}
//                 Load all
//               </button>
//             )}
//         </div>
//       </>
//     );
//   }
// }

// export default PageGrid;
import React, { useState, useEffect, useCallback, useContext } from 'react';
import { LangContext } from '../contexts/Lang';
export interface PageGridProps {
  columns?: number;
  fitContent?: boolean;
  className?: string;
  childrenLength?: any;
  childrenArray?: any[];
  children?: any;
}
const PageGrid = (props: PageGridProps) => {
  const { globalPageData } = useContext(LangContext);
  const [state, setState] = useState({
    deviceWidth: window.innerWidth,
    limit: 15,
  });
  const listen = useCallback(() => {
    setState((s) => {
      return {
        ...s,
        deviceWidth: window.innerWidth,
      };
    });
  }, [setState]);
  useEffect(() => {
    window.addEventListener('resize', listen);
    return () => {
      window.removeEventListener('resize', listen);
    };
  }, [listen]);
  const getColumns = () => {
    return props.columns || 5;
  };
  let columns = getColumns();
  let gridStyle = {
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
  };

  let className = 'section-grid';
  if (props.className) {
    className += ' ' + props.className;
  }
  return (
    <>
      <div
        style={gridStyle}
        className={`${className} ${
          props.childrenLength > 15 ? 'section-grid--many-items' : ''
        }`}>
        {props.childrenArray?.map(
          (child, index) =>
            index < state.limit && (
              <div className='section-grid-inner-container'>{child}</div>
            )
        )}
        {props.children}
      </div>
      <div className='section-padding' style={{ textAlign: 'center' }}>
        {props.childrenArray?.length &&
          state.limit < props.childrenArray.length && (
            <button
              className='btn'
              onClick={() =>
                setState({
                  deviceWidth: window.innerWidth,
                  limit: props?.childrenArray?.length || 0,
                })
              }>
              {globalPageData.lastInnAlle || 'Last inn alle'}
            </button>
          )}
      </div>
    </>
  );
};

export default PageGrid;
